import * as types from './types';

export const state = {
  currentPanel: 'steps',
  activeButton: 'steps',
  currentElement: null,
};

export const mutations = {
  [types.SIDEBAR_UPDATE_VISIBILITY](state, panel) {
    state.currentPanel = panel;
  },
  [types.SIDEBAR_UPDATE_ACTIVE_BUTTON](state, button) {
    state.activeButton = button;
  },
  [types.SIDEBAR_SET_ELEMENT](state, element) {
    state.currentElement = element;
  },
  [types.SIDEBAR_RESET_STATE](state) {
    state.currentPanel = 'steps';
    state.activeButton = 'steps';
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/sidebar/mutations.js
 **/